/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { faImages } from '@fortawesome/pro-regular-svg-icons';
import { CameraRecordData } from '../../../../../../../../models/record/items/camera-record.model';

@Component({
  selector: 'camera-record',
  templateUrl: './camera-record.component.html',
  styleUrls: ['./camera-record.component.scss'],
  standalone: false
})
export class CameraRecordComponent implements OnInit {
  @Input() record!: CameraRecordData;
  faImages = faImages;
  constructor() {}

  ngOnInit(): void {}
  getText(): string {
    let amountString = $localize`:Amount:Amount`;
    let toString = $localize`:to:to`;
    return `${amountString}: ${this.record.minAmount} ${toString} ${this.record.maxAmount}`;
  }
}
